import Autocomplete from "@gqlapp/base/field/Autocomplete";
import withProps from "recompose/withProps";
import { useEffect, useState } from "react";

/**
 *
 * @param props
 */
export default function fieldConfig (props: any) {
	let { setFieldValue, tabIndex, name, value, inputProps, ...rest }: any = props
	tabIndex = tabIndex || 1;

	return {
		...{ name, value, onRemove: setFieldValue },
		...{ component: Autocomplete, inputProps: { ...inputProps, tabIndex } },
		...{
			filterSelectedOptions: true,
			autoComplete: true,
			includeInputInList: true,
			filterOptions: (x: any) => x,
			onChange: ({}, newValue: any) => setFieldValue(props?.name, newValue),
			getOptionLabel: (option: any) => typeof option === 'string' ? option : option?.description || '',
		},
		...rest
	}
}

let timeout = null;

export const autocompleteProps = withProps(({ location, search: loadOptions })=>{
	let locationLabel = 'Your location'.t();
	let locationOpt = {
		description: locationLabel
	}

	const [ open, setOpen] = useState(false);
	const [ options, setOpts] = useState([]);
	const [ inputValue, setInputValue] = useState(null);

	function setOptions(options: any[]){
		let _OPTIONS = [];
		if(!!location?.current){
			_OPTIONS.push({ ...locationOpt, ...location?.current });
		}
		options.map((opt)=>_OPTIONS.push(opt));
		setOpts(_OPTIONS);
	}

	useEffect(function (){
		let active = true;
		if((inputValue === locationLabel || !inputValue || !open || !loadOptions)) {
			return;
		}

		new Promise(async resolve => {
			resolve(await loadOptions(inputValue, active));
		}).then(setOptions).catch(()=> null);


		return () => { active = false; }
	}, [ loadOptions, inputValue, open, locationLabel])


	let onInputChange = (function onInputChange(_: any, newInputValue: string) {
		clearTimeout(timeout);
		timeout = setTimeout(()=> setInputValue(newInputValue), 800);
	});

	const handleOpen = () => {
		setOpen(true);
	}

	const handleClose = () => {
		setOpen(false);
		setOptions([]);
	}

	return { autocompleteProps: { options, onInputChange, onOpen: handleOpen, onClose: handleClose } }
})